import React  from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import XLSX from 'xlsx';
import {Alert, Button} from "react-bootstrap";
import Modal from "react-bootstrap/es/Modal";
import PropTypes from "prop-types";
import {API_CALL_FAILED} from "../../redux/action-types";

/**
 * A class to use for static excel sheets (we know which columns we expect).
 * If we dont know which columns there on before hand, this file f
 */
class StaticExcelTools extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            confirmationRequired: false,
            showModal: false,
            errors: []
        };
        this.handleFile = this.handleFile.bind(this);
        this.exportFile = this.exportFile.bind(this);
    };

    componentDidUpdate() {
        if(this.state.importing && this.props.lastAction && this.props.lastAction.type === this.props.actionTypeImported) {
            this.setState({
                importing: false,
                errors: [],
                showModal:false
            })
        }

        if(this.state.importing && this.props.lastAction && this.props.lastAction.type === API_CALL_FAILED) {
            this.setState({
                importing: false,
                errors: ["Import failed.", this.props.lastAction.payload.message]
            })
        }
    }

    handleFile(file/*:File*/) {
        /* Boilerplate to set up FileReader */
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        reader.onload = (e) => {
            /* Parse data */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, {type:rABS ? 'binary' : 'array'});
            /* Get first worksheet */
            const ws = wb.Sheets[wb.SheetNames[0]];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws, {header:1}).filter(function(d) {
                return d.length > 0;    // Filter out empty data
            });

            this.convertDataForImport(data, function(validData) {
                /* Update state */
                this.setState({
                    data: validData,
                    confirmationRequired: true
                });
            }.bind(this));
        };
        if(rABS) reader.readAsBinaryString(file); else reader.readAsArrayBuffer(file);
    };

    importFile(e) {
        e.preventDefault();
        this.setState({
            importing: true
        });

        this.setState({confirmationRequired: false});
        this.props.importDataTarget(this.state.data);
    }

    exportFile(e) {
        e.preventDefault();
        this.exportCompatibleData(function(data) {
            const ws = XLSX.utils.aoa_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Kate "+this.props.subject);
            /* generate XLSX file and send to client */
            XLSX.writeFile(wb, this.props.fileName+".xlsx")
        }.bind(this));
    };

    convertDataForImport(data, onValidData) {
        // check that we have the proper column keys in our excel data
        let attributes = data.shift();
        if(JSON.stringify(this.props.columns) !== JSON.stringify(attributes)) {
            let expected = this.props.columns.join(", ");
            let actual = attributes.join(", ");
            return this.setState({
                confirmationRequired: false,
                errors: ["Invalid columns, can't import:\nRequired: "+expected+".\nGot: "+actual+"."],
            });
        }
        else {
            if(!this.props.importConversion) {
                throw new Error("Missing importConversion property on StaticExcelTools.")
            }
            let allConverted = [];
            let conversionErrors = [];

            for(let d = 0; d < data.length; d++) {
                try {
                    let converted = {};
                    for(let i in attributes) {
                        if(attributes.hasOwnProperty(i)) {
                            converted[attributes[i]] = data[d][i];
                        }
                    }

                    allConverted.push(this.props.importConversion(converted));
                }
                catch(ex) {
                    console.error(ex);
                    if(conversionErrors.indexOf(ex.message) === -1) {
                        conversionErrors.push(ex.message)
                    }
                }
            }

            this.setState({
                errors: conversionErrors,
                confirmationRequired: conversionErrors.length === 0
            });

            if(conversionErrors.length === 0) {
                onValidData(allConverted);
            }
        }
    }

    exportCompatibleData(callback) {
        if(this.props.data && this.props.exportDataSource) {
            throw new Error("props.data and props.exportDataSource are both set. You may not use both on StaticExcelTools.")
        }

        if(this.props.data) {
            this.convertDataForExport(this.props.data, callback);
        }
        else if(this.props.exportDataSource) {
            this.props.exportDataSource(function(data) {
                this.convertDataForExport(data, callback)
            }.bind(this))
        }
    }

    convertDataForExport(data, callback) {
        let convertedData = [];
        convertedData.push(this.props.columns); // Add the columns as table headers
        let conversionErrors = [];

        if(!this.props.exportConversion) {
            throw new Error("Missing exportConversion property on StaticExcelTools.")
        }

        for (let d = 0; d < data.length; d++) {
            try {
                let building = [];

                let converted = this.props.exportConversion(data[d]);
                for (let c = 0; c < this.props.columns.length; c++) {
                    let col = this.props.columns[c];
                    building.push(converted[col]);
                }

                convertedData.push(building);
            } catch(ex) {
                console.error(ex);
                if(conversionErrors.indexOf(ex.message) === -1) {
                    conversionErrors.push(ex.message)
                }
            }
        }

        this.setState({
            errors: conversionErrors
        });

        if(conversionErrors.length === 0) {
            callback(convertedData);
        }
    }

    closeModal(e) {
        if(e && e.preventDefault) e.preventDefault();
        this.setState({
            showModal: false ,
            confirmationRequired: false
        });
    }

    render() { return (
        <div>
            <div onClick={e => this.setState({ showModal: true })}>
                <i className="fas fa-file-excel"/>
            </div>
            <Modal show={this.state.showModal} onHide={e => this.closeModal(e)}>
                <Modal.Header closeButton>
                    <Modal.Title>Import/export {this.props.subject}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DragDropFile handleFile={this.handleFile}>
                        <h3>Export</h3>
                        <p>
                            Click on Export to download the current data as XLSX.
                        </p>

                        <h3>Import</h3>
                        <p>Or upload a file to import new data.</p>
                        <div><DataInput handleFile={this.handleFile}/></div>

                        {this.state.errors && this.state.errors.length > 0 ?
                            <Alert className="pre-line" bsStyle="danger">
                                {this.state.errors.map(e => <p key={e}>{e}</p>)}
                            </Alert>
                        : null}

                        {this.props.children}

                        {this.state.confirmationRequired ?
                            <Alert className="pre-line" bsStyle="warning">
                                Import {this.state.data.length} {this.props.subject}?
                            </Alert>
                            : null }
                    </DragDropFile>
                </Modal.Body>
                <Modal.Footer>
                    {this.state.confirmationRequired ?
                        <Button bsStyle="warning" onClick={e => this.importFile(e)}>Import</Button>
                    : null }
                    <Button bsStyle="success" onClick={e => this.exportFile(e)}>Export</Button>
                    <Button onClick={e => this.closeModal(e)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>

    ); };
};

StaticExcelTools.propTypes = {
    subject: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    actionTypeImported: PropTypes.string.isRequired,
    importDataTarget: PropTypes.func.isRequired,
    importConversion: PropTypes.func.isRequired,
    exportDataSource: PropTypes.func.isRequired,
    exportConversion: PropTypes.func.isRequired,
    columns: PropTypes.array.isRequired
};


/* -------------------------------------------------------------------------- */

/*
  Simple HTML5 file drag-and-drop wrapper
  usage: <DragDropFile handleFile={handleFile}>...</DragDropFile>
    handleFile(file:File):void;
*/
class DragDropFile extends React.Component {
    constructor(props) {
        super(props);
        this.onDrop = this.onDrop.bind(this);
    };

    suppress(evt) {
        evt.stopPropagation();
        evt.preventDefault();
    };

    onDrop(evt) { evt.stopPropagation(); evt.preventDefault();
        const files = evt.dataTransfer.files;
        if(files && files[0]) this.props.handleFile(files[0]);
    };

    render() { return (
        <div onDrop={this.onDrop} onDragEnter={this.suppress} onDragOver={this.suppress}>
            {this.props.children}
        </div>
    ); };
};

/*
  Simple HTML5 file input wrapper
  usage: <DataInput handleFile={callback} />
    handleFile(file:File):void;
*/
class DataInput extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    };
    handleChange(e) {
        const files = e.target.files;
        if(files && files[0]) this.props.handleFile(files[0]);
    };
    render() { return (
        <form className="form-inline">
            <div className="form-group">
                <input type="file" className="form-control" id="file" accept={SheetJSFT} onChange={this.handleChange} />
            </div>
        </form>
    ); };
}

/* list of supported file types */
const SheetJSFT = [
    "xlsx", "xlsb", "xlsm", "xls", "xml", "csv", "txt", "ods", "fods", "uos", "sylk", "dif", "dbf", "prn", "qpw", "123", "wb*", "wq*", "html", "htm"
].map(function(x) { return "." + x; }).join(",");

const mapStateToProps = state => {
    return { pendingCalls: state.pendingCalls, lastAction: state.lastAction};
};

export default withRouter(connect(mapStateToProps)(StaticExcelTools));



// WEBPACK FOOTER //
// ./src/components/reusables/StaticExcelTools.js